import { Row } from "antd/es";
import { useState, useEffect } from "react";
import { fetchImageHistory } from "../../../api";
import { ImageThumbGrid } from "../../MediaBrowser";


export const EvalImages = (props) => {
    const { model } = props;

    const [images, setImages] = useState([]);

    useEffect(() => {
        const path = model.path.replace('/unet', '');
        const queryString = `loras.path = "${path}"`;

        fetchImageHistory(100, { is_eval: true }, queryString)
            .then(images => setImages(images.values.map(h => ({ ...h.inference, '_timestamp': h['@timestamp'] }))
                .map(e => ({ args: e, url: e.images[0] }))));
    }, [model]);

    const loadArgs = (args) => window.dispatchEvent(new CustomEvent('custom.setArgs', { detail: args }));
    const setBaseImage = (args) => window.dispatchEvent(new CustomEvent('custom.setBaseImage', { detail: args }));
    const setViewing = (args) => window.dispatchEvent(new CustomEvent('custom.setViewing', { detail: args }));

    const selectImage = (args, url) => {
        loadArgs(args);
        setViewing(url);
    };

    return (<Row gutter={0}>
        <ImageThumbGrid
            images={images}
            selectImage={selectImage}
            setBaseImage={setBaseImage} />
    </Row>);
};
